/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 */

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { Error as PlatformError } from '../Platform';
import { PmcMessageType } from '@reachmedianetwork/post-message-client-rds-api';
import { PlayerPmc } from '../PlayerPmc';

/** */
export interface PlayerPackageInterface {
    /**
     * **Feature:** Retrieve list of locally stored player packages that can be
     * reinstalled
     * @throws {Error}
     * @throws {@link PlatformError}
     */
    getInstalledPackages(): Promise<Array<InstalledPackage>>;

    /**
     * **Feature:** Have player download and execute player package
     * @throws {Error}
     * @throws {@link PlatformError}
     */
    deployPackage(
        notificationChannel: string,
        playerUuid: string,
        guid: string,
        version: string,
        purgeDownloadedPackage: boolean
    ): Promise<void>;
}

export type InstalledPackage = {
    Guid: string;
    Name: string;
    VersionAsString: string;
    Description: string;
};

export function supportsPlayerPackage(platform: unknown): platform is PlayerPackageInterface {
    if (platform instanceof PlayerPmc) {
        return (
            platform.supportsMessage(PmcMessageType.PlayerPackagesInstalled) &&
            platform.supportsMessage(PmcMessageType.PlayerPackagesDeploy)
        );
    }

    return (
        platform instanceof Object &&
        'getInstalledPackages' in platform &&
        'deployPackage' in platform
    );
}
